/**
 * The function has a very specific use case. It is used to assert that a switch statement is exhaustive.
 * When a switch statement is exhaustive, it means that all possible values of the discriminated union are handled.
 * And when default case is reached, but the value still has some possible values, it means that the switch statement is not exhaustive.
 * It is immediately results in a compile types error and is visible as an error in the IDE.
 * @param message any message to be displayed in the error
 * @param value any value that was not expected to be reached
 * @example
 * type Feature = 'feature1' | 'feature2' | 'feature3';
 * const feature: Feature = 'feature3';
 * switch (feature) {
 *  case 'feature1':
 *    // do something
 *    break;
 * case 'feature2':
 *    // do something
 *    break;
 * default:
 *   assertExhaustiveMatch('Feature is not handled', feature); // Error: Feature is not handled. Value: 'feature3'.
 *   // The switch statement is not exhaustive. It is missing the case for 'feature3'.
 *   // The tsc immediately shows you an error for the type checking.
 * }
 */
export const assertExhaustiveMatch = (message: string, value: never): never => {
  throw new Error(`${message} Value: ${JSON.stringify(value)}`);
};
